import { FormSectionType } from '@/types/forms';
import { SWITCH_TYPE } from '@/types/forms/fields';

/**
 * Filter sections rendered as a one-click toggle chip instead of a popover.
 *
 * Keyed on `label_raw` rather than "any single-switch section" so the public
 * search rows ("Subdomain", "More") keep their popover — only the dashboard
 * Action Required filter is a plain on/off.
 */
export const TOGGLE_FILTER_SECTIONS: readonly string[] = ['action_required'];

/**
 * Whether a filter section is a one-click toggle. Shared by the desktop and
 * mobile filter rows so they stay in sync.
 */
export function isToggleFilterSection(section: FormSectionType): boolean {
  return (
    TOGGLE_FILTER_SECTIONS.includes(section.label_raw) &&
    section.fields.length === 1 &&
    section.fields[0].type === SWITCH_TYPE &&
    !!section.fields[0].name
  );
}
